export const siteInfo = {
  name: "看料社",
  slogan: "把散落的热点，整理成值得回看的专题",
  intro:
    "看料社是一个以热门爆料与网络热点深度整理为核心的内容资源库。我们把零散的爆料、合集与系列内容重新归档，做成结构清晰的专题，让你想看哪部点哪部，一次把来龙去脉看明白。",
  email: "contact@kanliaoshe.cn",
  workTime: "每日 09:00 - 22:00 更新",
  since: "2021",
};

export const categories = [
  {
    id: "variety",
    name: "娱乐综艺",
    desc: "名场面、赛制复盘与节目幕后花絮的完整整理。",
    count: 2,
  },
  {
    id: "influencer",
    name: "网红爆料",
    desc: "围绕直播间与社交平台舆论事件的资料归档。",
    count: 2,
  },
  {
    id: "screen",
    name: "影视幕后",
    desc: "从宣发博弈到口碑走势，梳理作品出圈的全过程。",
    count: 1,
  },
  {
    id: "esports",
    name: "电竞圈",
    desc: "转会期风云、赛区动态与选手舆论的纵向观察。",
    count: 1,
  },
  {
    id: "marketing",
    name: "商业营销",
    desc: "品牌传播中的翻车案例与公关应对复盘。",
    count: 1,
  },
  {
    id: "music",
    name: "音乐现场",
    desc: "音乐节与演唱会现场名场面、曲目与氛围记录。",
    count: 1,
  },
];

export const popularKeywords = [
  "在线看料",
  "看料资源库",
  "看料全集",
  "看料完整版",
  "看料系列",
  "看料专题",
  "热点事件整理",
  "爆料合集",
];